<template>
    <form action="" class="mb-6" id="FamilyRegistration">
        <div class="alert alert-success alert-full" role="alert" v-if="registered">
            {{ i18n.gratulujeme_registracia_bola_uspesna_potvrdenie_ako_aj_dalsie_informacie_posielame_na_mailove_adresy_uvedene_v_registracii_vitame_vas_v_rodine_stromakov }}
        </div>
        <div class="alert alert-full" role="alert" v-if="validationErrors && !registered">
            {{ i18n.niektore_polia_ste_nevyplnili_spravne_skontrolujte_ich_a_pokuste_sa_registrovat_znovu }}
        </div>
        <div class="columns is-multiline">
            <div class="column is-full is-half-desktop">
                <div class="form-header">
                    <div class="form-header-caption">
                        {{ i18n.zakladne_informacie }}
                    </div>
                </div>
                <div class="form-body">
                    <div class="form-input-group">{{ i18n.rodinny_klub_sz }}</div>
                    <div class="form-input">
                        <label class="form-input-label">{{ i18n.nazov_klubu_sz }} *</label>
                        <input type="text" class="form-input-element" v-model="family.name">
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['family.name'] ? validationErrors['family.name'][0] : ''
                            }}</small>
                    </div>
                    <template v-if="catalog === 'stromSK'">
						<div class="form-input">
							<input class="form-input-element-checkbox" v-model="seminar"
								   id="seminar" type="checkbox">
							<label for="seminar">{{ i18n.ucast_na_seminaroch }}</label>
						</div>
					</template>
                    <div class="form-input">
                        <label class="form-input-label">{{ i18n.ulica_a_cislo }}</label>
                        <input type="text" class="form-input-element" v-model="family.delivery_street">
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['family.delivery_street'] ? validationErrors['family.delivery_street'][0] : ''
                            }}</small>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="form-input">
                                <label class="form-input-label">{{ i18n.mesto }}</label>
                                <input type="text" class="form-input-element" v-model="family.delivery_city">
                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                        validationErrors['family.delivery_city'] ? validationErrors['family.delivery_city'][0] : ''
                                    }}</small>
                            </div>
                        </div>
                        <div class="column">
                            <div class="form-input">
                                <label class="form-input-label">{{ i18n.psc }}</label>
                                <input type="text" class="form-input-element" v-model="family.delivery_zip">
                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                        validationErrors['family.delivery_zip'] ? validationErrors['family.delivery_zip'][0] : ''
                                    }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="form-input">
                        <label class="form-input-label">{{ i18n.krajina }}</label>
                        <select class="form-input-element form-input-element-select"
                                v-model="family.delivery_country">
                            <option :value="null" selected disabled>{{ i18n.vyberte }}</option>
                            <option :value="item" v-for="(item, index) in countries">{{ item }}</option>
                        </select>
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['family.delivery_country'] ? validationErrors['family.delivery_country'][0] : ''
                            }}</small>
                    </div>
					<template v-if="catalog === 'stromSK' || family.delivery_country === 'Slovakia'">
						<div class="form-input">
							<label class="form-input-label">{{ i18n.okres_registration }}</label>
							<select class="form-input-element form-input-element-select" v-model="family.district_id">
								<option :value="null" selected disabled>{{ i18n.vyberte }}</option>
								<option :value="item.id" v-for="(item, index) in districts">{{ item.name }}</option>
							</select>
							<small class="invalid-form-input-message" v-if="validationErrors">{{
									validationErrors['family.district_id'] ? validationErrors['family.district_id'][0] : ''
								}}</small>
							<small class="form-input-element-help">{{ i18n.povinne_v_pripade_krajiny_slovensko }} *</small>
						</div>
					</template>
                    <div class="form-input-group">{{ i18n.veduci_rodinneho_klubu }}</div>
                    <div class="form-input">
                        <label class="form-input-label">{{ i18n.meno_a_priezvisko }}</label>
                        <input type="text" class="form-input-element" v-model="parent.name">
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['parent.name'] ? validationErrors['parent.name'][0] : ''
                            }}</small>
                    </div>
                    <div class="form-input">
                        <label class="form-input-label">{{ i18n.email_registration }} *</label>
                        <input type="text" autocomplete="email" class="form-input-element" v-model="parent.email">
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['parent.email'] ? validationErrors['parent.email'][0] : ''
                            }}</small>
                    </div>
                    <div class="form-input" v-if="!user">
                        <label class="form-input-label">{{ i18n.heslo }}</label>
                        <input type="password" autocomplete="new-password" class="form-input-element"
                               v-model="parent.password">
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['parent.password'] ? validationErrors['parent.password'][0] : ''
                            }}</small>
                    </div>
                    <div class="form-input">
                        <label class="form-input-label">{{ i18n['Telefón'] }} <span v-if="catalog === 'stromSK'">*</span></label>
                        <input type="text" class="form-input-element" v-model="parent.phone">
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['parent.phone'] ? validationErrors['parent.phone'][0] : ''
                            }}</small>
                    </div>
                </div>
            </div>
            <div class="column is-full is-half-desktop">
                <div class="form-header">
                    <div class="form-header-caption">
                        {{ i18n.fakturacne_udaje }}
                    </div>
                </div>
                <div class="form-body">
                    <div class="form-input-group">{{ i18n.fakturacne_udaje }}</div>
                    <div class="form-input">
                        <label class="form-input-label">{{ i18n.ulica_a_cislo }}</label>
                        <input type="text" class="form-input-element" v-model="family.street">
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['family.street'] ? validationErrors['family.street'][0] : ''
                            }}</small>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="form-input">
                                <label class="form-input-label">{{ i18n.mesto }}</label>
                                <input type="text" class="form-input-element" v-model="family.city">
                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                        validationErrors['family.city'] ? validationErrors['family.city'][0] : ''
                                    }}</small>
                            </div>
                        </div>
                        <div class="column">
                            <div class="form-input">
                                <label class="form-input-label">{{ i18n.psc }}</label>
                                <input type="text" class="form-input-element" v-model="family.zip">
                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                        validationErrors['family.zip'] ? validationErrors['family.zip'][0] : ''
                                    }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="form-input">
                        <label class="form-input-label">{{ i18n.krajina }}</label>
                        <select class="form-input-element form-input-element-select" v-model="family.country">
                            <option :value="null" selected disabled>{{ i18n.vyberte }}</option>
                            <option :value="item" v-for="(item, index) in countries">{{ item }}</option>
                        </select>
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['family.country'] ? validationErrors['family.country'][0] : ''
                            }}</small>
                    </div>
                    <div class="form-input-group">{{ i18n.nakupujem_na_firmu }}</div>
                    <div class="form-input">
                        <label class="form-input-label">{{ i18n.subjekt }}</label>
                        <input type="text" class="form-input-element" v-model="family.invoice_subject">
                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                validationErrors['family.invoice_subject'] ? validationErrors['family.invoice_subject'][0] : ''
                            }}</small>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <div class="form-input">
                                <label class="form-input-label">{{ i18n.invoice_ico }}</label>
                                <input type="text" class="form-input-element" v-model="family.invoice_ico">
                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                        validationErrors['family.invoice_ico'] ? validationErrors['family.invoice_ico'][0] : ''
                                    }}</small>
                            </div>
                        </div>
                        <div class="column">
                            <div class="form-input">
                                <label class="form-input-label">{{ i18n.invoice_dic }}</label>
                                <input type="text" class="form-input-element" v-model="family.invoice_dic">
                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                        validationErrors['family.invoice_dic'] ? validationErrors['family.invoice_dic'][0] : ''
                                    }}</small>
                            </div>
                        </div>
                        <div class="column">
                            <div class="form-input">
                                <label class="form-input-label">{{ i18n.invoice_ic_dph }}</label>
                                <input type="text" class="form-input-element" v-model="family.invoice_ic_dph">
                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                        validationErrors['family.invoice_ic_dph'] ? validationErrors['family.invoice_ic_dph'][0] : ''
                                    }}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="cart-wrap">
                    <div class="is-flex justify-content-between align-items-center py-4" style="flex-wrap: wrap">
                        <div>
                            <h2 class="headline headline--bigger">{{ i18n.zhrnutie_registracie }}</h2>
                            <div class="Delimiter mb-4"></div>
                        </div>
                        <div class="is-flex justify-content-end align-items-center py-4">
                            <div class="registration-pricing--discount" v-if="!isMonthly">
                                {{ i18n.zlava_25 }}
                            </div>
                            <div>{{ i18n.rocne }}</div>
                            <div class="toggleWrapper">
                                <input type="checkbox" v-model="isMonthly" class="mobileToggle"
                                       id="price-toggle">
                                <label for="price-toggle"></label>
                            </div>
                            <div>{{ i18n.mesacne }}</div>
                        </div>
                    </div>
                    <div class="columns is-multiline is-mobile is-vcentered">
                        <div class="column">
                            <h3>{{ i18n.rodinny_klub }}
                                <template v-if="isPlus">{{ i18n.rodinny_klub_plus }}</template>
                            </h3>
                        </div>
                        <div class="column has-text-right">
                            <div class="CartWrap-item__total checkout">
                                {{
                                    Intl.NumberFormat('sk-SK', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    }).format(isMonthly ? baseMonthly : basePrice)
                                }} {{ i18n.eur_lomeno_mes }}
                            </div>
                        </div>
                    </div>
                    <template v-if="seminar">
                        <div class="columns is-multiline is-mobile is-vcentered">
                            <div class="column">
                                <h3>{{ i18n.ucast_na_seminaroch_title }}</h3>
                            </div>
                            <div class="column has-text-right">
                                <div class="CartWrap-item__total checkout">

                                    {{
                                        Intl.NumberFormat('sk-SK', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }).format(this.seminarPrice)
                                    }} {{ i18n.eur_lomeno_mes }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <h2 class="cart-heading mb-4">{{ i18n.vyberte_sposom_platby }}</h2>
                    <div class="columns is-multiline is-mobile">
                        <div class="column">
                            <label for="payment_type_BANK"><input id="payment_type_BANK" type="radio"
                                                                  v-model="paymentType" value="BANK">
                                {{ i18n.bankovy_prevod }}
                            </label>
                        </div>
                    </div>
                    <div class="columns is-multiline is-mobile">
                        <div class="column">
                            <label for="payment_type_CARD"><input id="payment_type_CARD" type="radio"
                                                                  v-model="paymentType" value="CARD">
                              {{ i18n.platba_kartou }}
                            </label>
                        </div>
                    </div>
                    <div class="columns is-multiline"
                         v-if="parent.name && family.delivery_street && family.delivery_zip && family.delivery_city && family.delivery_country">
                        <div class="column"><h2 class="cart-heading mb-4">{{ i18n.sumar_udajov }}</h2>
                            <p><b>{{ i18n.meno_a_priezvisko_text }}:</b></p>
                            <p>{{ parent.name }}</p>
                            <p><b>{{ i18n.adresa_text }}:</b></p>
                            <p>{{ family.delivery_street }}</p>
                            <p>{{ family.delivery_zip }} {{ family.delivery_city }}</p>
                            <p>{{ family.delivery_country }}</p>
                            <p><b>{{ i18n.fakturacna_adresa_text }}:</b></p>
                            <p>{{ family.street }}</p>
                            <p>{{ family.zip }} {{ family.city }}</p>
                            <p>{{ family.country }}</p>
                            <template v-if="family.invoice_subject">
                                <p><b>{{ i18n.firemne_udaje_text }}:</b></p>
                                <p>{{ family.invoice_subject }}</p>
                                <p>{{ family.invoice_ico }}</p>
                                <p>{{ family.invoice_dic }}</p>
                                <p>{{ family.invoice_ic_dph }}</p>
                            </template>
                        </div>
                    </div>
                    <hr class="cart-hr">
                    <p class="has-text-left">
                        <label>
                            <input type="checkbox" v-model="agreements.general"> &nbsp; {{ i18n.suhlasim_so }} <a
                            class="orange-link" href="/vseobecne-podmienky-spoluprace" target="_blank">{{ i18n.vseobecnymi_podmienkami_spoluprace }}</a>
                        </label>
                        <br>
                        <span class="invalid-input" role="alert" v-if="validationErrors">
                {{ validationErrors['agreements.general'] ? validationErrors['agreements.general'][0] : '' }}<br>
            </span>


                        <input type="checkbox" v-model="agreements.media"> &nbsp; {{ i18n.suhlasim_so_zverejnovanim_obrazovych_a_obrazovo_zvukovych_zaznamov }} &nbsp; <span class="agreement-icon"
                                                                              @click="toggleAgreement(1)">?</span>
                        <span class="agreement-tooltip" v-if="activeAgreement === 1"><br>{{ i18n.suhlasim_so_zverejnovanim_obrazovych_a_obrazovo_zvukovych_zaznamov_description }}<br></span>

                        <br>
                        <input type="checkbox" v-model="agreements.results"> &nbsp; {{ i18n.suhlasim_so_zverejnenim_mojich_vysledkov_a_vysledkov_mojho_dietata }} &nbsp; <span class="agreement-icon"
                                                                                @click="toggleAgreement(2)">?</span><span
                        class="agreement-tooltip" v-if="activeAgreement === 2"><br>{{ i18n.suhlasim_so_zverejnenim_mojich_vysledkov_a_vysledkov_mojho_dietata_description }}<br></span>

                        <br>


                        <input type="checkbox" v-model="agreements.events"> &nbsp; {{ i18n.suhlasim_s_pouzitim_osobnych_udajov_mojho_dietata }} &nbsp; <span class="agreement-icon"
                                                          @click="toggleAgreement(3)">?</span><span
                        class="agreement-tooltip" v-if="activeAgreement === 3"><br>{{ i18n.suhlasim_s_pouzitim_osobnych_udajov_mojho_dietata_description }}<br></span>

                        <br>

                        <input type="checkbox" v-model="agreements.newsletter"> &nbsp; {{ i18n.suhlasim_s_pouzitim_emailu_rodica_uvedeneho_v_tejto_prihlaske_na_zasielanie_newslettera }} &nbsp; <span
                        class="agreement-icon" @click="toggleAgreement(4)">?</span><span class="agreement-tooltip"
                                                                                         v-if="activeAgreement === 4"><br>{{ i18n.suhlasim_s_pouzitim_emailu_rodica_uvedeneho_v_tejto_prihlaske_na_zasielanie_newslettera_description }}</span>

                    </p>
                    <h3 class="cart-heading cart-heading--green mb-4 has-text-right">
                        {{ i18n.k_uhrade }}:
                        {{
                            Intl.NumberFormat('sk-SK', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }).format(finalPrice)
                        }} €
                    </h3>
                    <div class="has-text-right">
                        <button type="button" class="button button-orange" @click="register()">
                            {{ i18n.dokoncit_registraciu }} <template v-if="loading"> &nbsp; <span class="material-icons rotating">hourglass_bottom</span></template>
                        </button>
                        <br> <small>{{ i18n.s_povinnostou_platby }}</small></div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {sk} from 'vuejs-datepicker/dist/locale'

export default {
    components: {
        Datepicker
    },
    props: {
        districts: Array,
        countries: Array,
        isPlus: Boolean,
        monthlyPrice: Number,
        monthlyPricePlus: Number,
        yearlyPrice: Number,
        yearlyPricePlus: Number,
        seminarPrice: Number,
        user: {
            type: Object,
            default: null
        },
        pricing: String,
        registrationRoute: String,
		catalog: String
    },
    data: function () {
        return {
            activeAgreement: 0,
            sk: sk,
            isMonthly: this.pricing === 'monthly',
            paymentType: 'BANK',
            loading: false,
            family: {
                name: null,
                street: this.user ? this.user.street : null,
                zip: this.user ? this.user.zip : null,
                city: this.user ? this.user.city : null,
                district_id: this.user ? this.user.district_id : null,
                country: this.user ? this.user.country : null,
                invoice_subject: this.user ? this.user.invoice_subject : null,
                invoice_ico: this.user ? this.user.invoice_ico : null,
                invoice_dic: this.user ? this.user.invoice_dic : null,
                invoice_ic_dph: this.user ? this.user.invoice_ic_dph : null,
                delivery_street: this.user ? this.user.delivery_street : null,
                delivery_zip: this.user ? this.user.delivery_zip : null,
                delivery_city: this.user ? this.user.delivery_city : null,
                delivery_country: this.user ? this.user.delivery_country : null,
            },
            parent: {
                name: this.user ? this.user.name : null,
                email: this.user ? this.user.email : null,
                password: null,
                phone: this.user ? this.user.phone : null
            },
            validationErrors: null,
            registered: false,
            agreements: {
                general: false,
                newsletter: false,
                events: false,
                results: false,
                media: false
            },
            basePrice: this.isPlus ? this.yearlyPricePlus : this.yearlyPrice,
            baseMonthly: this.isPlus ? this.monthlyPricePlus : this.monthlyPrice,
            seminar: false,
            finalPrice: this.pricing === 'yearly' ? (this.isPlus ? this.yearlyPricePlus * 12 : this.yearlyPrice * 12) : (this.isPlus ? this.monthlyPricePlus : this.monthlyPrice),
            lang: document.documentElement.lang,
            i18n: i18n
        };
    },
    mounted() {
    },
    watch: {
        isMonthly: function (val) {
            let monthly = val;
            let addSeminar = this.seminar ? this.seminarPrice : 0;

            if (!monthly) {
                this.finalPrice = (this.basePrice * 12) + (addSeminar * 12);
            } else {
                this.finalPrice = (this.baseMonthly) + (addSeminar);
            }
        },
        seminar: function (val) {
            if (val) {
                if (!this.isMonthly) {
                    this.finalPrice += this.seminarPrice * 12;
                } else {
                    this.finalPrice += this.seminarPrice;
                }
            } else {
                if (!this.isMonthly) {
                    this.finalPrice -= this.seminarPrice * 12;
                } else {
                    this.finalPrice -= this.seminarPrice;
                }
            }
        }
    },
    methods: {
        register() {
            if(!this.loading) {
                this.loading = true;
                axios
                    .post(this.registrationRoute, {
                        family: this.family,
                        parent: this.parent,
                        agreements: this.agreements,
                        isMonthly: this.isMonthly,
                        payment: this.paymentType,
                        seminar: this.seminar,
                        isPlus: this.isPlus
                    })
                    .then(response => {
                        if(this.paymentType === 'BANK') {
                            this.registered = true;
                            this.loading = false;
                            document.getElementById('FamilyRegistration').scrollIntoView();
                            window.scrollBy(0, -75);
                        } else {
                            window.location.href = response.data.redirect;
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.registered = false;
                        if (error.response.status === 422) {
                            this.validationErrors = error.response.data.errors;
                        }

                        document.getElementById('FamilyRegistration').scrollIntoView();
                        window.scrollBy(0, -75);
                    });
            }
        },
        toggleAgreement(number) {
            if (this.activeAgreement === number) {
                this.activeAgreement = 0;
            } else {
                this.activeAgreement = number;
            }
        }
    }
};
</script>

<style scoped lang="scss">
.agreement-icon {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    color: white;
    background: #6086b7;
    display: inline-block;
    cursor: pointer;
    position: relative;
    bottom: 2px;
    font-size: 9px;
    font-weight: bold;
    text-align: center;
    line-height: 15px;
}

.agreement-tooltip {
    color: #6086b7;
    font-size: 13px;
}
</style>
